import axios from "axios";
import { headerConfig } from "../utility/RequestHeaderConfig";
import { BASE_API_URL, BASE_LOGIN_API_URL } from "../utility/URL";



const getYearList = async () => {
    const response = await axios
        .post(BASE_LOGIN_API_URL + "yearList", {});
    return response;
};


const getApiList = async () => {
    const response = await axios
        .get(BASE_LOGIN_API_URL + "api-list", {});
    return response;
};


// const accountList = async () => {
//     const response = await axios
//         .post(BASE_API_URL + "account/list",{}, headerConfig);
//     return response;
// };

const dayList = async () => {
    const response = await axios
        .post(BASE_API_URL + "day/allDay",{}, headerConfig);
    return response;
};

const  accountReportLink = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "menu/report-link",data, headerConfig);
    return response;
};



const commonService = {
    getYearList,
    getApiList,
    dayList,
    accountReportLink
    
    
};

export default commonService;